import { oceanLogixDexieDb } from "./db";
import {
  LocalAuditRepository,
  LocalCredentialPackageRepository,
  LocalGeneratedDocumentRepository,
  LocalOrganizationRepository,
  LocalSessionRepository,
  LocalSyncOperationRepository,
  LocalTankRepository,
  LocalTripCargoRepository,
  LocalTripRepository,
  LocalVesselInstallationRepository,
  LocalVesselParticularsRepository,
  LocalVesselRepository,
  LocalVoyageRepository,
} from "./repositories";
import { AtomicOperationalWriteCoordinator } from "./transactions";

export const createLocalDataAccess = (db = oceanLogixDexieDb) => {
  const auditRepository = new LocalAuditRepository(db);
  const syncOperationRepository = new LocalSyncOperationRepository(db);

  return {
    db,
    repositories: {
      organizations: new LocalOrganizationRepository(db),
      vessels: new LocalVesselRepository(db),
      vesselParticulars: new LocalVesselParticularsRepository(db),
      tanks: new LocalTankRepository(db),
      voyages: new LocalVoyageRepository(db),
      trips: new LocalTripRepository(db),
      tripCargo: new LocalTripCargoRepository(db),
      auditEntries: auditRepository,
      syncOperations: syncOperationRepository,
      credentialPackages: new LocalCredentialPackageRepository(db),
      localSessions: new LocalSessionRepository(db),
      vesselInstallations: new LocalVesselInstallationRepository(db),
      generatedDocuments: new LocalGeneratedDocumentRepository(db),
    },
    coordinators: {
      atomicOperationalWrite: new AtomicOperationalWriteCoordinator({
        db,
        auditRepository,
        syncOperationRepository,
      }),
    },
  };
};
